import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'h3-horizontal-form',
  templateUrl: './horizontal-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HorizontalFormComponent {
  @Input({ required: true }) labelWidth!: number;
}
